module.exports = __webpack_public_path__ + "360d38404e6cb1b38fdf0cc8d7ffd9ca.svg";